export default "/fonts/vendor/boxicons/boxicons.eot?dfc882ec9689f820c7c961f70883a576";